import { render } from "./SettingsPages.vue?vue&type=template&id=957d210a"
import script from "./SettingsPages.vue?vue&type=script&lang=js"
export * from "./SettingsPages.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__